var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-button',_vm._g(_vm._b({attrs:{"color":"primary","iconI":"mdi-check-circle","noSpantext":""},scopedSlots:_vm._u([{key:"name",fn:function(){return [_vm._v(_vm._s(_vm.$t("commons.validate")))]},proxy:true}])},'avs-button',{ ..._vm.$attrs },false),{ ..._vm.$listeners }))
}
var staticRenderFns = []

export { render, staticRenderFns }